<template>
  <div>
    <span v-if="flag==1">
    <el-breadcrumb class="navcss" separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ name: 'idclist' }">IDC列表</el-breadcrumb-item>
      <el-breadcrumb-item>ButelProxy管理</el-breadcrumb-item>
    </el-breadcrumb>
    <el-row>
      <el-col>
        <el-button type="primary" @click="addButelProxy"
                   v-if="btnInList('idc_butelproxy','idc_butelproxy_add')">新增ButelProxy</el-button>
      </el-col>
    </el-row>
      </span>
    <span v-if="flag==2">
      <b>代理配置校验不一致</b>
    </span>
    <el-table v-if="flag==1" :data="tableData" style="width: 100%">
      <!--      <el-table-column align="center" type="index" width="20"></el-table-column>-->
      <el-table-column align="center" prop="id" label="ID"></el-table-column>
      <el-table-column align="center" prop="nodeId" label="业务ID"></el-table-column>
      <el-table-column align="center" prop="deviceName" label="设备名称"></el-table-column>
      <el-table-column align="center" prop="operate" label="操作" width="450">
        <template v-slot="{row}">
          <!--          <el-dropdown @command="bindNodeId" v-if="row.proxyInstanceId !=0">-->
          <!--            <el-button type="primary" size="mini" style="margin-left: 10px;margin-right: 10px">-->
          <!--              {{conventNodeName(row)}}-->
          <!--              <i class="el-icon-arrow-down el-icon&#45;&#45;right"></i>-->
          <!--            </el-button>-->
          <!--            <el-dropdown-menu slot="dropdown" style="height: 100px;overflow-y: scroll">-->
          <!--              <el-dropdown-item v-show="row.nodeId !=0" :command="commandValue('a', row)">解除绑定</el-dropdown-item>-->
          <!--              <el-dropdown-item :command="commandValue('b', row)">新增业务ID</el-dropdown-item>-->
          <!--              <el-dropdown-item :command="commandValue(item.nodeId, row)" v-for="(item, index) in instanceIdList"-->
          <!--                                :key="index">-->
          <!--                <div v-if="item.lazyInstanceId" :title="'已绑定实例ID:'+item.lazyInstanceId"><i-->
          <!--                  class="el-icon-warning-outline" style="color:red;"></i> {{item.nodeId}}-->
          <!--                </div>-->
          <!--                <div v-else>{{item.nodeId}}</div>-->
          <!--              </el-dropdown-item>-->
          <!--            </el-dropdown-menu>-->
          <!--          </el-dropdown>-->
          <el-button size="mini" type="primary" :disabled="row.sendMsgLoading" @click="syncInfo(row)"
                     v-if="btnInList('idc_butelproxy','idc_butelproxy_sync')">同步
          </el-button>
          <el-button size="mini" type="primary"
                     v-if="row.proxyInstanceId > 0 && btnInList('idc_butelproxy','idc_butelproxy_view')"
                     @click="viewProxyInstance(row)">查看
          </el-button>
          <!--          :disabled="row.proxyInstanceId > 0"-->
          <el-button size="mini" type="primary" @click="editButelProxy(row)"
                     v-if="btnInList('idc_butelproxy','idc_butelproxy_edit')">编辑
          </el-button>
          <el-button size="mini" type="primary" @click="preShow(row)"
                     v-if="btnInList('idc_butelproxy','idc_butelproxy_preview')">预览
          </el-button>
          <el-button size="mini" type="danger" @click="delButelProxyConfirm(row.id)"
                     v-if="btnInList('idc_butelproxy','idc_butelproxy_del')">删除
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-table v-if="flag==2" :data="verifyData" style="width: 100%">
      <el-table-column align="center" type="index" width="20"></el-table-column>
      <el-table-column align="center" prop="proxyId" label="代理ID"></el-table-column>
      <el-table-column align="center" prop="errorInfo" label="描述">
        <template v-slot="{row}">
          <el-button type="text" @click="showAllErrInfo(row.errorInfo)">{{ getErrorInfo(row.errorInfo) }}</el-button>
        </template>
      </el-table-column>
      <el-table-column align="center" prop="operate" label="操作" width="450">
        <template v-slot="{row}">
          <!--          <el-button size="mini" type="primary" v-if="row.proxyInstanceId > 0"-->
          <!--                     @click="viewProxyInstance(row)">查看-->
          <!--          </el-button>-->
          <!--          :disabled="row.proxyInstanceId > 0"-->
          <el-button size="mini" type="primary" @click="editButelProxy(row)">修正</el-button>

          <!--          <el-button v-if="flag==2" size="mini" type="danger" @click="closeProxy(row.id)">关闭</el-button>-->
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      v-if="flag==1"
      class="fy"
      background
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="currentPage"
      :page-sizes="[20,40,60,80]"
      :page-size="pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="totalElement"
    ></el-pagination>

    <el-dialog
      :title="ButelProxyTitle"
      :visible="butelProxyVisible"
      :show-close="false"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="1200px">
      <el-form label-position="left" style="margin-left: 25px;" :model="butelProxyData" ref="butelProxyData"
               label-width="90px" :rules="rules">
        <span v-if="flag==1">
        <el-row>
          <el-col :span="9">
            <el-form-item label="选择集成" prop="unitId">
          <el-select :disabled="isEdit"
                     v-model="butelProxyData.unitId"
                     filterable
                     :filter-method="filterIntergrationOption"
                     @change="selectUnit(butelProxyData.unitId)"
          >
            <!-- <el-option label="全部" value="-1">全部</el-option> -->
            <el-option v-for="unit in integrationListFilter"
                       :key="unit.id"
                       :label="unit.alias"
                       :value="unit.id">
              <span style="float: left">{{ unit.alias }}</span>
              <span style="float: right; color: #8492a6; font-size: 13px">{{ unit.version }}</span>
            </el-option>
          </el-select>
        </el-form-item>

          </el-col>
        </el-row>

        <el-row style="margin-left: 100px;">
          <el-col
            :span="5"
            v-for="(item, index) in filterArray"
            :key="index"
            style="margin-bottom:40px;width: 25%;">
            <div v-if="!isEdit"
                 @click="handleCheckedChange(item, index, $event)" class="divChecked">
              <el-card
                :body-style="{ padding: '0px'}"
                :class="{active:index == active}"
                shadow="hover"
                :offset="1"
                style="width: 86%;height: 100%;cursor:pointer;"
              >
                <div style="padding: 14px;">
                  <module :item="item"/>
                </div>
              </el-card>
            </div>
         <div v-else
              class="divChecked">
              <el-card
                :body-style="{ padding: '0px'}"
                :class="{active:index == active}"
                shadow="hover"
                :offset="1"
                style="width: 86%;height: 100%;cursor:pointer;"
              >
                <div style="padding: 14px;">
                  <module :item="item"/>
                </div>
              </el-card>
            </div>

          </el-col>
        </el-row>

          <el-row>
            <el-form-item label="业务ID" prop="nodeId">
              <el-input v-model="butelProxyData.selectedNodeId" style="width:100px"></el-input>
              <span v-if="availableNode!=''"> 可用范围：{{ availableNode }}</span>
            </el-form-item>
          </el-row>
        <el-row>
          <el-col :span="9">
            <el-form-item label="设备" prop="deviceId">
              <el-select :disabled="isEdit"
                         v-model="butelProxyData.deviceId" placeholder="请选择设备" @change="deviceChange">
                <el-option v-for="(option, idx) in deviceList"
                           :key="idx"
                           :label="option.deviceName"
                           :value="option.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="1"><el-button :disabled="isEdit" type="primary" @click="addNetCard()"
                                       style="margin-left: 10px;"
                                       icon="el-icon-circle-plus-outline"></el-button></el-col>
        </el-row>
        </span>
        <div v-if="flag==2"
             style="width:250px;margin-bottom: 10px;margin-left: 90px;border:1px solid #dadeff;padding: 20px">
          <div>设备名称：{{ showInfo.deviceName }}</div>
          <div>idcId：{{ showInfo.idcId }}</div>
          <div>集成名称：{{ showInfo.integrationVersionAlias }}</div>
          <div>集成版本：{{ showInfo.integrationVersionVersion }}</div>
          <div>模块类型：{{ showInfo.moduleType }}</div>
          <div>模块版本：{{ showInfo.moduleVersion }}</div>
        </div>
        <div v-for="(item, index) in butelProxyData.list" :key="index">
          <el-row>
            <el-col :span="9">
              <el-form-item label="接收网卡" :prop="'list.' + index + '.recvNetCardId'" :rules="rules.recvNetCardId">
                <el-select v-model="item.recvNetCardId" placeholder="请选择网卡" @change="changeNetcard(index,$event)">
                  <el-option v-for="(option, idx) in netCardList"
                             :key="idx"
                             :label="option.netCardName +':'+ option.ipCodeStr + ':' +option.netPlaneName"
                             :value="option.id"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item style="margin-left: 50px" label="发送网卡" :prop="'list.' + index + '.sendNetCardId'"
                            :rules="rules.sendNetCardId">
                <el-select v-model="item.sendNetCardId" placeholder="请选择网卡"
                           @change="sendNetCardChange(index,$event)">
                  <el-option v-for="(option, idx) in netCardList"
                             :key="idx"
                             :label="option.netCardName +':'+ option.ipCodeStr + ':' +option.netPlaneName"
                             :value="option.id"></el-option>
                </el-select>

              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-button type="primary" @click="viewNetPlane(index)" style="margin-left: 10px;">拓扑</el-button>
              <el-button type="primary" @click="addNetCard(index)" style="margin-left: 10px;"
                         icon="el-icon-circle-plus-outline"></el-button>
              <el-button type="warning" @click="subNetCard(index)" style="margin-left: 10px;"
                         icon="el-icon-remove-outline"></el-button>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="9">
              <el-form-item label="服务" :prop="'list.' + index + '.moduleType'" :rules="rules.moduleType">
                <el-select v-model="item.type" placeholder="请选择" @change="serviceTypeChange(index)"
                           style="width:110px;margin-right: 5px">
                  <el-option label="红云模块" :value="0"></el-option>
                  <el-option label="自定义" :value="1"></el-option>
                </el-select>
                <el-select v-if="item.type==0" v-model="item.moduleType" placeholder="请选择模块类型"
                           @change="moduleTypeChange(index)"
                           style="width:210px" clearable>
                  <el-option v-for="(option, idx) in moduleTypeList"
                             :key="idx"
                             :label="option"
                             :value="option"></el-option>
                </el-select>
                <el-input v-else v-model="item.moduleType" style="width: 210px"></el-input>
              </el-form-item>
            </el-col>
            <!--选择自定义时不显示实例-->
            <el-col :span="8" v-if="item.type!=1">
              <span v-if="flag==1">
                <el-form-item style="margin-left: 50px" label="实例" :prop="'list.' + index + '.instanceId'">
                <el-select
                  v-model="item.nodeId" @change="getAddrGroup($event,index,false)" placeholder="请选择实例">
                  <el-option v-for="(option, idx) in item.instanceList"
                             :key="idx"
                             :label="'实例ID:'+option.instanceId + '，业务ID:' + option.nodeId"
                             :value="option.nodeId"></el-option>
                </el-select>
              </el-form-item>
              </span>
              <span v-if="flag==2">
                <el-form-item style="margin-left: 50px" label="实例" :prop="'list.' + index + '.instanceId'">
                  <el-select v-model="item.nodeId" @change="getAddrGroup($event,index,false)" placeholder="请选择实例">
                    <el-option v-for="(option, idx) in item.instanceList"
                               :key="idx"
                               :label="'实例ID:'+option.instanceId + '，业务ID:' + option.nodeId"
                               :value="option.nodeId"></el-option>
                    </el-select>
                </el-form-item>
              </span>
            </el-col>
            <el-col :span="1" v-if="item.statusFlag==1">
              <el-tooltip :content="item.desc" effect="light" placement="top">
                <!--                title="当前实例已删除"-->
                <i class="el-icon-warning"
                   style="font-size: 30px; color: red;margin-top: 5px; margin-left: 5px;"></i>
              </el-tooltip>
            </el-col>
          </el-row>
          <!--选择自定义时不显示地址组 v-if="item.addrGroupList.length>0 && item.type!=1"-->

          <div v-if="item.type==0">
            <el-form-item label="地址组" :prop="'list.' + index + '.activeAddr'" :rules="rules.activeAddr">
              <el-tag type="success" class="activeAddr" v-if="item.addrNode"
                      style="text-align:left;margin-right: 10px;height: 140px;">
                <span style="display: block;height: 20px;">网络平面:{{ item.addrNode.netPlaneName }}</span>
                <span style="display: block;height: 20px;">网络平面ID:{{ item.addrNode.netPlaneId }}</span>
                <span style="display: block;height: 20px;">地址组ID:{{ item.addrNode.id }}</span>
                <span style="display: block;height: 20px;">地域信息:{{ item.addrNode.domainName }}</span>
                <span style="display: block;height: 20px;">设备名称:{{ item.addrNode.deviceName }}</span>
                <span style="display: block;height: 20px;">IDC:{{ item.addrNode.idcName }}</span>
              </el-tag>
              <el-button type="primary" style="margin-left: 10px;" @click="selectAddrGroupClick(index)">选择地址组
              </el-button>
              <el-radio-group style="margin-left: 200px;" v-model="item.proxyStatus">
                <el-radio-button :label="0">默认</el-radio-button>
                <el-radio-button :label="1">只生成内网</el-radio-button>
                <el-radio-button :label="2">只生成外网</el-radio-button>
                <el-radio-button :label="3">不生成</el-radio-button>
              </el-radio-group>
            </el-form-item>
            <div v-for="(sip, idxaddr) in item.sourceAddrList" :key="idxaddr*2000">
              <el-row>
                <el-form-item label="源地址">
                  <template #label>
                    源地址
                    <span v-if="!sip.valid">
                      <el-tooltip content="无效代理" effect="light" placement="top">
                        <i class="el-icon-warning-outline" style="color: #d7d705;font-size:16px"></i>
                      </el-tooltip>
                    </span>
                  </template>
                  <el-input v-model="sip.ip+':'+sip.port" :disabled="true"
                            style="width: 175px;margin-left: 5px;"></el-input>
                  <i style="margin-left: 5px" class="el-icon-back"></i>
                  <el-input v-model="sip.sendIpCodeStr+':'" :disabled="true"
                            style="width: 150px;margin-left: 10px;"></el-input>
                  <el-input v-model="sip.sendPort" style="width: 80px;margin-left: 10px;"></el-input>
                  <i style="margin-left: 5px" class="el-icon-back"></i>
                  <el-input v-model="sip.recvIpCodeStr+':'" :disabled="true"
                            style="width: 150px;margin-left: 10px;"></el-input>
                  <el-input v-model="sip.recvPort" style="width: 80px;margin-left: 10px;margin-right: 5px;"></el-input>
                  <span>{{ conventProtocol(sip.protocol) }}</span>
                  <el-button v-if="item.sourceAddrList.length > 1" type="danger" size="small" icon="el-icon-delete"
                             circle @click="subAddr(index,idxaddr)" style="margin-left: 10px;"></el-button>
                  <span v-if="sip.extendInfo" style="margin-left: 15px">{{ sip.extendInfo }}</span>
                </el-form-item>
              </el-row>
            </div>
          </div>
          <div v-else v-for="(fip, idxf) in item.freeSource" :key="idxf*1100">
            <el-row>
              <el-form-item label="源地址">
                <el-input v-model="fip.addr"
                          style="width: 175px;margin-left: 5px;"></el-input>
                <i style="margin-left: 5px" class="el-icon-back"></i>

                <el-input v-model="fip.sendIpCodeStr+':'" :disabled="true"
                          style="width: 150px;margin-left: 10px;"></el-input>
                <el-input v-model="fip.sendPort" style="width: 80px;margin-left: 10px;"></el-input>
                <i style="margin-left: 5px" class="el-icon-back"></i>
                <el-input v-model="fip.recvIpCodeStr+':'" :disabled="true"
                          style="width: 150px;margin-left: 10px;"></el-input>
                <el-input v-model="fip.recvPort" style="width: 80px;margin-left: 10px;margin-right: 5px;"></el-input>
                <!--                <span v-if="item.type==0">{{ conventProtocol(sip.protocol) }}</span>-->
                <el-select v-model="fip.protocol" placeholder="请选择" clearable
                           style="width:110px;margin-right: 5px">
                  <el-option label="udp" :value="1"></el-option>
                  <el-option label="tcp" :value="2"></el-option>
                  <el-option label="udp/tcp" :value="3"></el-option>
                </el-select>
                <span v-if="fip.extendInfo">扩展信息：{{ fip.extendInfo }}</span>
                <!--                <el-button v-if="item.sourceAddrList.length > 1" type="danger" size="small" icon="el-icon-delete"-->
                <!--                           circle @click="subAddr(index,idxaddr)" style="margin-left: 10px;"-->
                <!--                ></el-button>-->
              </el-form-item>
            </el-row>
          </div>
          <div v-if="item.delAddrList && item.delAddrList.length>0" style="margin-bottom: 20px">
            <i class="el-icon-arrow-right" v-if="!item.isShowIgnore"
               style="margin-left: 30px;cursor: pointer" @click="showIgnore(item)"></i>
            <span v-else>
                  <i class="el-icon-arrow-down" v-if="item.isShowIgnore"
                     style="margin-left: 30px;cursor: pointer" @click="showIgnore(item)"></i>
                  <div v-for="(delItem, delIndex) in item.delAddrList" :key="delIndex">
                  <div style="margin-left: 90px;margin-bottom: 10px">
                    <el-input v-model="delItem.ip+':'+delItem.port" :disabled="true"
                              style="width: 175px;margin-left: 5px;"></el-input>
                    <span style="margin-left: 30px">{{ conventProtocol(delItem.protocol) }}</span>
                     <el-button type="primary" icon="el-icon-plus" circle size="mini"
                                style="margin-left: 30px"
                                @click="addSourceAddr(index,delIndex)"></el-button>
                    <span style="margin-left: 30px" v-if="delItem.extendInfo">{{ delItem.extendInfo }}</span>

                  </div>
                </div>
                </span>
          </div>
        </div>
        <el-row style="text-align: center;">
          <el-button type="primary" @click="saveProxyClick('butelProxyData')">提 交</el-button>
          <el-button @click="resetForm()">取 消</el-button>
        </el-row>
      </el-form>
    </el-dialog>

    <!--    预览-->
    <el-dialog
      title="预览"
      :visible.sync="preView"
      width="98%"
      v-loading="preLoading"
      :modal-append-to-body="false">
      <el-tree
        :data="preTreeData"
        node-key="id"
        :expand-on-click-node="false"
        style="color: #2b2b2b;width: 100%">
      <span class="custom-tree-node" slot-scope="{ node, data }">
        <span v-if="node.level==1">
          <span style="display:inline-block;width: 180px">{{ data.moduleType }}</span>
        <span style="margin-left: 30px;width: 200px;">instanceId:{{ data.instanceId }}</span>
        <span style="margin-left: 30px;display:inline-block;width: 100px;">nodeId:{{ data.nodeId }}</span>
        <span style="margin-left: 30px;display:inline-block;width: 150px;">网络平面ID:{{ data.netPlaneId }}</span>
          <span style="padding-left: 5px">
            <el-button type="text" size="normal" @click="ipTip(data.addr)"
                       style="display:inline-block;width: 230px;color: #2b2b2b;margin-left: 30px;font-size: 17px;text-align: left">{{
                showIp(data.addr)
              }}</el-button>
          </span>
          <!--          <span style="margin-left: 30px;display:inline-block;width: 390px;">-->
          <!--            groupID：{{showGroup(data.groupInfos)}}-->
          <!--          </span>-->

          <el-button type="text" size="normal" @click="groupTip(data.groupInfos)"
                     style="color: #2b2b2b;font-size: 17px;display:inline-block;text-align: left">
            <span style="white-space: pre-wrap;">groupId：{{ showGroup(data.groupInfos) }}</span>
          </el-button>
          <!--          <span style="margin-left: 30px">-->
          <!--            {{isShowAppkey(data.groupInfos)}}-->
          <!--          </span>-->
        </span>

        <span v-if="node.level==2">
          <span style="display:inline-block;margin-left: 30px;width:100px;" v-if="data.relation==1">NAT</span>
          <span style="display:inline-block;margin-left: 30px;width:100px;" v-if="data.relation==2">butelproxy</span>
          <span style="margin-left: 30px;display:inline-block;width: 150px;">网络平面ID:{{ data.netPlaneId }}</span>
          <el-tooltip placement="top" effect="light">
            <div slot="content">
              <div class="content">
                <div>ispId：{{ data.ispId }}</div>
              </div>
            </div>
            <span style="margin-left: 30px;display:inline-block;width: 100px;">ISP:{{ data.ispName }}</span>
          </el-tooltip>
          <el-tooltip placement="top" effect="light">
            <div slot="content">
              <div class="content">
                <div>country：{{ data.area.country }}</div>
                <div>province：{{ data.area.province }}</div>
                <div>city：{{ data.area.city }}</div>
                <div>region：{{ data.area.region }}</div>
              </div>
            </div>
            <el-button type="text"
                       style="color: #2b2b2b;margin-left: 30px;font-size: 15px;display:inline-block;width: 200px;text-align: left">{{
                data.area.address
              }}</el-button>
          </el-tooltip>

          <el-button type="text" size="normal" @click="ipTip(data.addr)"
                     style="color: #2b2b2b;margin-left: 30px;font-size: 17px;display:inline-block;width: 230px;text-align: left"><span
            style="white-space: pre-wrap;">{{ showIp(data.addr) }}</span></el-button>
        </span>
        <span>
        </span>
      </span>
      </el-tree>
      <el-row style="text-align:center;margin-top: 20px">
        <el-button @click="preView = false">取 消</el-button>
      </el-row>
    </el-dialog>
    <addr-node v-if="showViewAddrNode" :showViewAddrNode="showViewAddrNode" :addrGroupList="addrGroupNodes"
               :selectIdx="selectIdx" :selectedNodeId="butelProxyData.selectedNodeId"
               :viewNetPlaneItme="viewNetPlaneItme"
               @editCallback="editCallback"/>
    <jtopo-net-plane v-if="showViewNetPlane" :showViewNetPlane="showViewNetPlane" :viewNetPlaneItme="viewNetPlaneItme"
                     @editCallback="editNetPlaneCallback"/>
  </div>
</template>

<script>
import {Loading} from "element-ui";
import Module from "../../instance/Module.vue";
import AddrNode from './AddrNode'
import JtopoNetPlane from '../privatenetplane/JtopoNetPlane'
import {mapMutations, mapState} from "vuex";

export default {
  name: "ButelProxyList",
  components: {Module, AddrNode, JtopoNetPlane},
  data() {
    let _this = this
    let nodeIdValidate = (rule, value, callback) => {
      // if (_this.nodeName == "绑定业务ID") {
      //   callback(new Error('请选择业务ID'))
      // } else {
      //   callback()
      // }
      if (this.availableNodeList) {
        for (let i = 0; i < this.availableNodeList.length; i++) {
          let nodeRange = this.availableNodeList[i]
          if (nodeRange.start <= this.butelProxyData.selectedNodeId && nodeRange.end >= this.butelProxyData.selectedNodeId) {
            callback()
            return
          }
        }
        callback(new Error('请输入正确的业务ID!'))
      }

    }
    let activeAddrValidate = (rule, value, callback) => {
      const idx = Number(rule.field.split(".")[1])
      let list = _this.butelProxyData.list

      if (list[idx].sourceAddrList && list[idx].sourceAddrList.length > 0) {
        callback()
      } else {
        callback(new Error('请选择地址组'))
      }
    }
    return {
      verifyData: [],
      portsArr: [],
      availableNode: "",
      availableNodeList: [],
      form: {
        nodeId: ""
      },
      activeNames: "1",
      preTreeData: [],
      preLoading: false,
      preView: false,
      isEdit: false,
      warnShow: false,
      bindItem: null,
      showInfo: {},
      inputView: false,
      showViewAddrNode: false,
      viewNetPlaneItme: null,
      showViewNetPlane: false,
      addrGroupNodes: [],
      // proxyDeviceList: [],
      selectIdx: 0,
      ButelProxyTitle: "",
      active: null,
      current: null,
      unitInfo: {},
      butelProxyVisible: false,
      idcId: null,
      currentPage: 1,
      pageSize: 20,
      totalElement: 0,
      deviceList: [],
      netCardList: [],
      moduleTypeList: [],
      integrationListFilter: [],
      moduleArray: [], //模块列表
      UnitList: [],
      recvNetCardItem: null,
      sendNetCardItem: null,
      tableData: [],
      butelProxyData: {
        id: null,
        deviceId: "",
        unitId: "",
        integrationVersionVersion: "",
        moduleType: "",
        moduleVersion: "",
        netPlaneName: "",
        selectedNodeId: "",
        list: [
          {
            proxyStatus: 0,
            sendNetCardId: "",
            recvNetCardId: "",
            type: "",
            moduleType: "",
            instanceId: "",
            activeAddr: 0,
            showInstanceFlag: false,
            instanceList: [],
            addrGroupList: [],
            sourceAddrList: [],
            delAddrList: [],
            freeSource: [],
            addrNode: null,
            isShowIgnore: false,
            preNetCardId: ""
          }
        ]
      },
      rules: {
        unitId: [
          {required: true, message: '请选择集成名称', trigger: 'change'}
        ],
        deviceId: [
          {required: true, message: '请选择设备', trigger: 'change'}
        ],
        recvNetCardId: [
          {required: true, message: '请选择接收网卡', trigger: 'change'}
        ],
        sendNetCardId: [
          {required: true, message: '请选择发送网卡', trigger: 'change'}
        ],
        moduleType: [
          {required: true, message: '请选择模块类型', trigger: 'change'}
        ],
        instanceId: [
          {required: true, message: '请选择实例', trigger: 'change'}
        ],
        nodeId: [
          {validator: nodeIdValidate, required: true, message: '请输入正确的业务ID', trigger: 'blur'}
        ],
        activeAddr: [
          {validator: activeAddrValidate, required: true, message: '请选择地址组'}
        ],
      },
      proxyInfo: null,
      relationProxyList: [],
      proxyTableData: [],
      preNetCardId: "",
      currentIdcId: ""
    }
  },
  methods: {
    ...mapMutations(['getListOperations']),
    showAllErrInfo(arr) {
      this.$notify.closeAll();
      let msg = arr.map(item => item).join('<br/>')
      this.$notify({
        position: 'bottom-right',
        dangerouslyUseHTMLString: true,
        message: msg,
        duration: 0,//是否自动关闭
        customClass: 'notifyStyle',
      });
    },
    getErrorInfo(arr) {
      return arr[0];
    },
    showIgnore(item) {
      item.isShowIgnore = !item.isShowIgnore;
    },
    addSourceAddr(index, delIndex) {
      let obj = this.butelProxyData.list[index];
      obj.delAddrList[delIndex].recvIpCodeStr = obj.sourceAddrList[0].recvIpCodeStr;
      obj.delAddrList[delIndex].sendIpCodeStr = obj.sourceAddrList[0].sendIpCodeStr;
      obj.sourceAddrList.push(obj.delAddrList[delIndex])
      obj.delAddrList.splice(delIndex, 1);
    },
    sendNetCardChange(index, e) {
      if (this.butelProxyData.list[index].type != undefined) {
        if (this.butelProxyData.list[index].type == 0) {
          let srcId = "";
          let dstId = "";
          let ipCodeStr = "";
          this.netCardList.forEach(s => {
            if (s.id == this.butelProxyData.list[index].preNetCardId) {
              srcId = s.netPlaneId;
            }
            if (e == s.id) {
              dstId = s.netPlaneId;
              ipCodeStr = s.ipCodeStr
            }
          })
          if (srcId == dstId) {
            this.butelProxyData.list[index].sourceAddrList.forEach(q => {
              q.sendIpCodeStr = ipCodeStr;
            })
          } else {
            // this.butelProxyData.list[index].instanceId = "";
            // this.butelProxyData.list[index].nodeId = "";
            this.butelProxyData.list[index].addrNode = null;
            this.butelProxyData.list[index].sourceAddrList = [];
            this.butelProxyData.list[index].freeSource = [];
          }
        } else {
          this.netCardList.forEach(item => {
            if (item.id == e) {
              this.butelProxyData.list[index].freeSource.forEach(q => {
                q.sendIpCodeStr = item.ipCodeStr;
              })
            }
          })
        }
      }
      this.butelProxyData.list[index].preNetCardId = this.butelProxyData.list[index].sendNetCardId
    },
    changeNetcard(index, e) {
      if (this.netCardList && this.netCardList.length > 0) {
        if (this.butelProxyData.list[index].type != undefined) {
          this.netCardList.forEach(item => {
            if (item.id == e) {
              if (this.butelProxyData.list[index].type == 0) {
                this.butelProxyData.list[index].sourceAddrList.forEach(q => {
                  q.recvIpCodeStr = item.ipCodeStr;
                })
              } else {
                this.butelProxyData.list[index].freeSource.forEach(q => {
                  q.recvIpCodeStr = item.ipCodeStr;
                })
              }
            }
          })
        }
      }
    },
    serviceTypeChange(index) {
      if (this.butelProxyData.list[index].type == 1) {
        let obj = this.butelProxyData.list[index];
        obj.freeSource = [];
        obj.delAddrList = [];
        let arr = []
        let freeObj = {
          addr: "",
          ip: "",
          port: 0,
          sendIpCodeStr: "",
          sendPort: 0,
          recvIpCodeStr: "",
          recvPort: 0,
          protocol: 3
        }
        arr.push(freeObj)
        this.netCardList.forEach(e => {
          if (obj.sendNetCardId == e.id) {
            freeObj.sendIpCodeStr = e.ipCodeStr
          }
          if (obj.recvNetCardId == e.id) {
            freeObj.recvIpCodeStr = e.ipCodeStr
          }
        })
        let that = this
        that.$set(that.butelProxyData.list[index], 'freeSource', arr);
      }
    },
    groupTip(item) {
      this.$notify.closeAll();
      if (item && item.length > 0) {
        let groupID = [];
        item.forEach(e => {
          let html =
            "groupId：" + "<span>" + e.groupId + "</span>" + "<br>" +
            "appkey：" + "<span>" + e.appkey + "</span>" + "<br>" + "<br>";
          groupID.push(html);
        });
        let str = groupID.toString().replace(/,/g, "");
        this.$notify({
          // title: '自定义位置',
          position: 'bottom-right',
          dangerouslyUseHTMLString: true,
          message: str,
          duration: 0,//是否自动关闭
          customClass: 'notifyStyle'
        });
      }
    },
    showGroup(item) {
      if (item && item.length > 0) {
        let groupID = [];
        let str = "";
        item.forEach(e => {
          str = e.groupId;
          groupID.push(str);
        });
        let showGroupid;
        if (groupID && groupID.length > 1) {
          showGroupid = groupID[0] + "...";
        } else {
          showGroupid = groupID[0];
        }
        return showGroupid
      }
    },
    ipTip(item) {
      this.$notify.closeAll();
      let ipArr = [];
      item.forEach(e => {
        let protocol;
        if (e.protocol == 1) {
          protocol = "UDP"
        } else if (e.protocol == 2) {
          protocol = "TCP"
        } else {
          protocol = "UDP&TCP"
        }
        let html =
          "<span>" + e.ip + "</span>" +
          "<span style='margin-left: 30px'>" + e.port + "</span>" +
          "<span style='margin-left: 30px'>" + protocol + "</span>" +
          "<span style='margin-left: 30px'>" + e.extendInfo + "</span>" + "<br>";
        ipArr.push(html);
      });
      // var reg = /[,，]/g;
      // let str = ipArr.toString().replace(reg, "$&\r\n");
      let str = ipArr.toString().replace(/,/g, "");

      this.$notify({
        // title: '自定义位置',
        position: 'bottom-right',
        dangerouslyUseHTMLString: true,
        message: str,
        duration: 0,//是否自动关闭
        customClass: 'notifyStyle'
      });
    },
    showIp(ipArr) {
      let ipStr = [];
      let showIP = "";
      for (let i = 0; i < ipArr.length; i++) {
        let a = ipArr[i].ip + ":" + ipArr[0].port + "\n";
        ipStr.push(a);
        if (ipStr.length > 1) {
          showIP = ipArr[0].ip + ":" + ipArr[0].port + "...";
        } else {
          showIP = ipArr[0].ip + ":" + ipArr[0].port;
        }
      }
      return showIP;
    },
    preShow(row) {
      let _this = this;
      _this.preView = true;
      _this.preTreeData = [];
      _this.preLoading = true;
      let url = this.baseUrl3 + 'management3/unify/route/preview/' + row.id;
      this.$axios.get(url)
        .then(({data: {msg, data, code}}) => {
          if (code == 20000) {
            _this.preTreeData = data;
            _this.preLoading = false;
          } else {
            _this.preView = false;
            _this.preLoading = false;
            _this.$message({showClose: true, message: msg, type: 'error'});
            console.log(msg);
          }
        })
        .catch(err => {
          _this.preView = false;
          _this.preLoading = false;
          console.log(err);
        })
    },
    closeProxy(item) {
      if (this.relationProxyList && this.relationProxyList.length > 0) {
        this.relationProxyList.forEach((e, i) => {
          if (e.proxyId == item) {
            this.relationProxyList.splice(i, 1);
          }
        });
        localStorage.setItem("relationProxyList", JSON.stringify(this.relationProxyList));
        this.getProxyList();
      }
    },
    getProxyList() {
      let proxyIdList = [];
      if (this.verifyData && this.verifyData.length > 0) {
        this.verifyData.forEach(e => {
          proxyIdList.push(e.proxyId);
        });
      }
      let data = {
        proxyId: proxyIdList
      };
      this.$axios.post(this.baseUrl3 + 'management3/instance/GetProxyListByProxyId', data)
        .then(({data: {msg, data, code}}) => {
          if (code == 20000) {
            if (data) {
              // this.proxyTableData = data;
              data.forEach(e => {
                this.showInfo = {
                  id: e.id,
                  deviceName: e.deviceName,
                  idcId: e.idcId,
                  integrationVersionAlias: e.integrationVersionAlias,
                  integrationVersionVersion: e.integrationVersionVersion,
                  moduleType: e.moduleType,
                  moduleVersion: e.moduleVersion,
                };
              });
              // this.proxyDeviceList.push(this.showInfo);
            } else {
              // this.proxyTableData = []
            }
          } else {
            this.$message({showClose: true, message: msg, type: 'error'});
            console.log(msg)
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    conventProtocol(protocol) {
      if (protocol == 1) {
        return "udp"
      } else if (protocol == 2) {
        return "tcp"
      } else {
        return "tcp/udp"
      }
    },
    viewNetPlane(idx) {
      let _this = this;
      let obj = this.butelProxyData.list[idx];
      for (let i = 0; i < _this.netCardList.length; i++) {
        if (obj.sendNetCardId == _this.netCardList[i].id) {
          _this.viewNetPlaneItme = {
            netPlaneName: _this.netCardList[i].netPlaneName,
            id: _this.netCardList[i].netPlaneId
          }
        }
      }
      this.showViewNetPlane = true;
    },
    editNetPlaneCallback() {
      let _this = this;
      _this.viewNetPlaneItme = null;
      _this.showViewNetPlane = false;
    },
    selectAddrGroupClick(idx) {
      let obj = this.butelProxyData.list[idx];
      // obj.delAddrList = []
      let _this = this;
      _this.getAddGroupChain(obj, obj.nodeId).then(data => {
        if (data) {
          _this.selectIdx = idx;
          for (let i = 0; i < _this.netCardList.length; i++) {
            if (obj.sendNetCardId == _this.netCardList[i].id) {
              _this.viewNetPlaneItme = {
                netPlaneName: _this.netCardList[i].netPlaneName,
                id: _this.netCardList[i].netPlaneId
              }
            }
          }
          this.addrGroupNodes = obj.addrGroupList
          _this.showViewAddrNode = true
        }

      })
    },
    editCallback(item) {
      if (item) {
        let obj = this.butelProxyData.list[item.selectIdx];
        obj.delAddrList = []
        let instanceId;
        obj.instanceList.forEach(e => {
          if (e.nodeId == obj.nodeId) {
            instanceId = e.instanceId
          }
        })
        obj.addrNode = item.param.data;
        this.addrGroupClick(item.selectIdx, item.param.data, 0, instanceId);
      }
      this.showViewAddrNode = false;
    },
    viewProxyInstance(row) {
      this.$router.push({
        name: 'deployinstancelist',
        params: {
          currentPage: 1,
          serviceAgentId: row.proxyInstanceId,
          bsType: "proxy",
          idcId: this.idcId,
        }
      })
    },
    syncInfo(row) {
      let _this = this;
      _this.$set(row, 'sendMsgLoading', true);
      let data = {
        id: row.id
      };
      this.$axios.post(this.baseUrl3 + 'management3/proxy/sync/proxy', data)
        .then(({data: {msg, data, code}}) => {
          if (code == 20000) {

          } else {
            _this.$message({showClose: true, message: msg, type: 'error'})
            console.log(msg)
          }
          _this.initData();
        })
        .catch(err => {
          console.log(err)
        })
    },
    // bindNodeId(command) {
    //   // if (command=="add"){
    //   //   this.$confirm('直接新增业务ID 或 输入指定业务ID?', '提示', {
    //   //     distinguishCancelAndClose:true,
    //   //     confirmButtonText: '直接新增',
    //   //     cancelButtonText: '输入指定业务ID',
    //   //     type: 'warning'
    //   //   }).then(() => {
    //   //     this.addNodeID()
    //   //   }).catch((action) => {
    //   //     // if(action == "close"){
    //   //     //
    //   //     // }else if(action == "cancel"){
    //   //     //   this.formData.nodeId ="";
    //   //     //   this.inputView=true
    //   //     // }
    //   //   });
    //   // }
    //   this.butelProxyData.selectedNodeId = item;
    //   // const {row, command} = item
    //   // this.bindItem = row;
    // },
    addButelProxy() {
      this.ButelProxyTitle = "新增ButelProxy";
      this.availableNode = "";
      this.isEdit = false;
      this.getAvailableNode();
      this.id = null;
      this.butelProxyData = {
        id: null,
        deviceId: "",
        unitId: "",
        integrationVersionVersion: "",
        moduleType: "",
        moduleVersion: "",
        netPlaneName: "",
        selectedNodeId: "",
        list: [
          {
            proxyStatus: 0,
            sendNetCardId: "",
            recvNetCardId: "",
            moduleType: "",
            instanceId: "",
            activeAddr: 0,
            flag: 1,
            showInstanceFlag: false,
            instanceList: [],
            addrGroupList: [],
            sourceAddrList: [],
            delAddrList: [],
            freeSource: [],
            isShowIgnore: false
            // sourceAddrList: [{
            //   ip: "",
            //   port: "",
            //   sendIpCodeStr: "",
            //   sendPort: "",
            //   recvIpCodeStr: "",
            //   recvPort: "",
            // }]
          }
        ]
      };
      this.active = null;
      this.current = null;
      this.moduleArray = [];
      this.butelProxyVisible = true;
      this.$nextTick(() => {
        this.$refs["butelProxyData"].clearValidate()
      })
    },
    resetForm() {
      this.butelProxyVisible = false
    },
    getModuleTypeList() {
      let _this = this;
      _this.moduleTypeList = [];
      this.$axios.get(this.baseUrl3 + 'instance/moduleType/list')
        .then(({data: {msg, data, code}}) => {
          if (code == 20000) {
            _this.moduleTypeList = data;
          } else {
            _this.$message({showClose: true, message: msg, type: 'error'})
            console.log(msg)
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    getDeviceList() {
      let data = {
        pageNo: 1,
        pageSize: 10000000,
        idcId: this.idcId
      };
      this.deviceList = [];
      let _this = this;
      this.$axios.post(this.baseUrl3 + 'management3/device/list', data)
        .then(({data: {msg, data, code}}) => {
          if (code == 20000) {
            _this.deviceList = data.deviceList;
          } else {
            _this.$message({showClose: true, message: msg, type: 'error'})
            console.log(msg)
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    deviceChange() {
      let data = {
        deviceId: this.butelProxyData.deviceId
      };
      let _this = this;
      this.netCardList = [];
      for (let i = 0; i < _this.butelProxyData.list.length; i++) {
        _this.butelProxyData.list[i].recvNetCardId = '';
        _this.butelProxyData.list[i].sendNetCardId = ''
      }
      this.$axios.post(this.baseUrl3 + 'management3/netcard/list', data)
        .then(({data: {msg, data, code}}) => {
          if (code == 20000) {
            _this.netCardList = data;
            _this.getResource()
          } else {
            _this.$message({showClose: true, message: msg, type: 'error'})
            console.log(msg)
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    subAddr(index, idxaddr) {
      let obj = this.butelProxyData.list[index];
      obj.delAddrList.push(obj.sourceAddrList[idxaddr])
      obj.sourceAddrList.splice(idxaddr, 1);
    },
    getResource() {
      let param = {
        id: this.butelProxyData.deviceId
      }
      this.$axios.post(this.baseUrl3 + 'management3/device/getResourceById', param)
        .then(({data: {code, data, msg}}) => {
          if (code != 20000) {
            this.$message.error('获取资源定义失败！' + msg)
          } else {
            this.portsArr = []
            data.forEach(e => {
              let obj = {
                range: e.portRange,
                port: e.ports
              }
              this.portsArr.push(obj)
            })
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    getNodeIdAndInstanceId(obj, moduleType) {
      this.$axios.get(this.baseUrl3 + 'management3/instance/online/list/' + moduleType)
        .then(({data: {msg, data, code}}) => {
          if (code == 20000) {
            let arr = []
            for (let i = 0; i < data.length; i++) {
              let insObj = {
                instanceId: data[i].instanceId,
                nodeId: data[i].nodeId,
              }
              arr.push(insObj)
              this.$set(obj, 'instanceList', arr)
              // obj.instanceList.push(insObj);
            }
            this.$nextTick(() => {
              this.$forceUpdate();
            })
          } else {
            this.$message({showClose: true, message: msg, type: 'error'})
            console.log(msg)
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    moduleTypeChange(idx) {
      let obj = this.butelProxyData.list[idx];
      obj.addrNode = null;
      obj.instanceId = "";
      obj.nodeId = "";
      obj.sourceAddrList = [];
      obj.delAddrList = [];
      obj.addrGroupId = "";
      //obj.activeAddr = null;
      this.recvNetCardItem = null;
      this.sendNetCardItem = null;
      obj.addrGroupList = [];
      if (obj.sendNetCardId == "") {
        this.$message({
          showClose: true,
          message: "请选择发送网卡",
          type: "warning"
        });
        return
      }
      // let data = {
      //   "sendNetCardId": obj.sendNetCardId,
      //   "moduleType": obj.moduleType
      // };
      obj.instanceList = [];
      obj.showInstanceFlag = false;
      let _this = this;
      this.$axios.get(this.baseUrl3 + 'management3/instance/online/list/' + obj.moduleType)
        .then(({data: {msg, data, code}}) => {
          if (code == 20000) {
            for (let i = 0; i < data.length; i++) {
              let insObj = {
                instanceId: data[i].instanceId,
                nodeId: data[i].nodeId,
              }
              obj.instanceList.push(insObj);
            }
            _this.$nextTick(() => {
              _this.$forceUpdate();
            })
          } else {
            _this.$message({showClose: true, message: msg, type: 'error'})
            console.log(msg)
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.initData()
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.initData()
    },
    addNetCard(idx) {
      let obj = {
        sendNetCardId: "",
        recvNetCardId: "",
        moduleType: "",
        instanceId: "",
        showInstanceFlag: false,
        instanceList: [],
        addrGroupList: [],
        sourceAddrList: [],
        delAddrList: [],
        freeSource: [],
        isShowIgnore: false,
        addrNode: null,
        proxyStatus: 0
      }
      this.butelProxyData.list.push(obj);
    },
    subNetCard(idx) {
      this.butelProxyData.list.splice(idx, 1)
    },
    getAddrGroup(nodeId, idx, edit) {
      if (!edit) {
        this.butelProxyData.list[idx].addrGroupList = [];
        this.butelProxyData.list[idx].sourceAddrList = [];
        this.butelProxyData.list[idx].addrNode = null;
        this.butelProxyData.list[idx].proxyStatus = 0;
      }
      let obj = this.butelProxyData.list[idx];
      if (this.relationProxyList && this.relationProxyList.length > 0) {
        this.relationProxyList.forEach(e => {
          if (obj.instanceId == e.oldInstanceId) {
            this.warnShow = true
          } else {
            this.warnShow = false
          }
        })
      }
      if (!edit) {
        obj.showInstanceFlag = false;
      }


      this.getAddGroupChain(obj, nodeId)
      // for (let instance of obj.instanceList) {
      //   if (instance.instanceId == obj.instanceId) {
      //     obj.addrGroupList = instance.addrGroupList;
      //   }
      // }
      // console.log(obj.addrGroupList)
      let _this = this;
      _this.$nextTick(() => {
        _this.$forceUpdate();
      })
    },
    getAvailableNode(row) {
      let data = {
        id: row ? row.id : 0
      }
      this.$axios.post(this.baseUrl3 + 'management3/proxy/nodeList/available', data)
        .then(({data: {msg, data, code}}) => {
          if (code == 20000) {
            this.availableNodeList = data;
            let str = "";
            if (data && data.length > 0) {
              let arr = []
              data.forEach(e => {
                let start = e.start
                let end = e.end
                if (start == end) {
                  arr.push(start)
                } else {
                  arr.push(start + "~" + end)
                }
              })
              this.availableNode = arr.join(",")
            }

          } else {

          }
        })
        .catch(err => {
          console.log(err);
        })
    },
    getAddGroupChain(obj, nodeId) {
      let data = {
        sendNetCardId: obj.sendNetCardId,
        nodeId: nodeId,
        moduleType: obj.moduleType,
      }
      return this.$axios.post(this.baseUrl3 + 'management3/addrGroupChain ', data)
        .then(({data: {msg, data, code}}) => {
          if (code == 20000) {
            obj.addrGroupList = data;
            return true
          } else {
            this.$message.error(msg)
          }
        })
        .catch(err => {
          console.log(err);
        })
    },
    addrGroupClick(idx, addrgroup, addridx, instanceId) {
      let obj = this.butelProxyData.list[idx];
      //obj.activeAddr = addridx;
      obj.addrGroupId = addrgroup.id
      let data = {
        addrGroupId: addrgroup.id,
        instanceId: instanceId
      }
      let recvNetCardItem = null;
      let sendNetCardItem = null;
      for (let netCard of this.netCardList) {
        if (netCard.id == obj.recvNetCardId) {
          recvNetCardItem = netCard;
        }
        if (netCard.id == obj.sendNetCardId) {
          sendNetCardItem = netCard;
        }
      }
      let _this = this;
      obj.sourceAddrList = []
      this.$axios.post(this.baseUrl3 + 'management3/proxy/addrgroup/addrinfo', data)
        .then(({data: {msg, data, code}}) => {
          if (code == 20000) {
            let _sourceAddrList = data
            let _sourceAddrArray = [];
            for (let sourceAddr of _sourceAddrList) {
              sourceAddr.addrInfoId = addrgroup.id;
              sourceAddr.ip = addrgroup.ipStr;
              sourceAddr.sendPort = 0;
              sourceAddr.recvPort = sourceAddr.port;
              sourceAddr.recvIpCodeStr = recvNetCardItem.ipCodeStr;
              sourceAddr.sendIpCodeStr = sendNetCardItem.ipCodeStr;
              sourceAddr.valid = sourceAddr.valid;
              _sourceAddrArray.push(sourceAddr)
            }
            obj.sourceAddrList = _sourceAddrArray
          } else {
            _this.$message({showClose: true, message: msg, type: 'error'})
            console.log(msg)
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    handleCheckedChange(row, index, e) {
      this.active = index;
      this.current = row;
    },
    filterIntergrationOption(val) {
      const allOptions = [...this.UnitList]
      if (!val) {
        this.integrationListFilter = allOptions
      } else {
        this.integrationListFilter = allOptions.filter(option => option.alias.toLowerCase().indexOf(val.toLowerCase()) > -1)
      }
    },
    // 选择集成后，显示该集成下的模块
    selectUnit(unitId) {
      this.active = null;
      this.current = null;
      this.unitInfo = this.UnitList.filter(u => u.id == unitId)[0]
      this.moduleArray = []
      let loading = Loading.service({
        fullscreen: true,
        text: "数据加载中..."
      });

      let _this = this
      this.$axios
        .get(this.moduleUrl + "integration/Version/" + _this.unitInfo.alias + "/" + _this.unitInfo.version)
        .then(({data: {msg, data, code}}) => {
          if (code == 20000) {
            // this.moduleArray = data.moduleList ? data.moduleList : []
            if (data.moduleList && data.moduleList.length > 0) {
              data.moduleList.forEach(element => {
                if (element.moduleName == "butelproxy") {
                  _this.moduleArray.push({
                    name: element.moduleName,
                    alias: element.moduleAlias,
                    id: element.moduleId,
                    versionId: element.moduleVersionId,
                    version: element.moduleVersion,
                    hasServiceHelper: element.hasServiceHelper
                  })
                }
              });
              if (_this.butelProxyData.moduleType && _this.butelProxyData.moduleVersion) {
                _this.moduleArray.forEach((e, idx) => {
                  if (_this.butelProxyData.moduleType == e.name && _this.butelProxyData.moduleVersion == e.version) {
                    _this.handleCheckedChange(e, idx, null)
                  }
                })
              } else {
                if (_this.moduleArray.length > 0) {
                  _this.handleCheckedChange(_this.moduleArray[0], 0, null)
                }
              }

            }
          } else {
            this.$message({showClose: true, message: msg, type: "error"});
            console.log(msg);
          }
          loading.close();
        })
        .catch(err => {
          console.log(err);
          loading.close();
        });
    },
    findIntegration() {
      this.$axios
        .get(this.moduleUrl + "integration/Version/findAll")
        .then(({data: {msg, data, code}}) => {
          if (code == 20000) {
            this.UnitList = data ? data : [];
            this.integrationListFilter = data ? data : []
          } else {
            this.$message({showClose: true, message: msg, type: "error"});
            console.log(msg);
          }
        }).catch(err => {
        console.log('获取集成-请求失败')
      });
    },
    saveProxy() {
      // let idcID;
      // this.butelProxyData.list.forEach(item => {
      //   delete item.delAddrList;
      // })
      // if (this.relationProxyList && this.relationProxyList.length > 0) {
      //   // idcID = this.showInfo.idcId
      // } else {
      //   idcID = this.idcId
      // }
      let data = {
        id: this.butelProxyData.id ? this.butelProxyData.id : 0,
        idcId: this.isEdit ? this.currentIdcId : this.idcId,
        deviceId: this.butelProxyData.deviceId,
        integrationVersionAlias: this.unitInfo.alias,
        integrationVersionVersion: this.unitInfo.version,
        moduleType: this.current.name,
        moduleVersion: this.current.version,
        // ignoreIpList: item.delAddrList,
        list: [],
        nodeId: parseInt(this.butelProxyData.selectedNodeId)
      }
      let newInstanceList = [];
      for (let i = 0; i < this.butelProxyData.list.length; i++) {
        let item = this.butelProxyData.list[i];
        let obj = {
          sendNetCardId: item.sendNetCardId,
          recvNetCardId: item.recvNetCardId,
          // moduleType: item.moduleType,
          module: item.moduleType,
          type: item.type,
          nodeId: item.nodeId,
          // instanceId: item.instanceId,
          addrGroupId: item.addrGroupId,
          sourceIpList: [],
          ignoreIpList: [],
          proxyStatus: item.proxyStatus,
        };
        newInstanceList.push(item.instanceId);


        if (item.delAddrList && item.delAddrList.length > 0) {
          for (let k = 0; k < item.delAddrList.length; k++) {
            let ignore = item.delAddrList[k];
            let newObj = {
              addr: ignore.addr,
              attr: ignore.attr,
              extendInfo: ignore.extendInfo,
              ip: ignore.ip,
              port: parseInt(ignore.port),
              protocol: ignore.protocol,
              recvIpCodeStr: ignore.recvIpCodeStr,
              recvPort: parseInt(ignore.recvPort),
              sendIpCodeStr: ignore.sendIpCodeStr,
              sendPort: parseInt(ignore.sendPort),
              valid: ignore.valid,
            }
            obj.ignoreIpList.push(newObj)
          }
        }
        if (item.type == 0) {
          for (let j = 0; j < item.sourceAddrList.length; j++) {
            let sourceAddr = item.sourceAddrList[j];
            let newObj = {
              // id: sourceAddr.id,
              // addrInfoId: sourceAddr.addrInfoId,
              attr: sourceAddr.attr,
              protocol: parseInt(sourceAddr.protocol),
              srcAddr: sourceAddr.addr,
              sendPort: parseInt(sourceAddr.sendPort),
              recvPort: parseInt(sourceAddr.recvPort),
            };
            obj.sourceIpList.push(newObj)
          }
          // data.list.push(obj);
        } else {
          for (let j = 0; j < item.freeSource.length; j++) {
            let sourceAddr = item.freeSource[j];
            let newObj = {
              // id: sourceAddr.id,
              // addrInfoId: sourceAddr.addrInfoId,
              // attr: sourceAddr.attr,
              protocol: parseInt(sourceAddr.protocol),
              srcAddr: sourceAddr.addr,
              sendPort: parseInt(sourceAddr.sendPort),
              recvPort: parseInt(sourceAddr.recvPort),
            };
            obj.sourceIpList.push(newObj)
          }
          // data.list.push(obj);
        }
        data.list.push(obj);
      }
      let saveFlag = false;
      if (this.relationProxyList && this.relationProxyList.length > 0) {
        this.relationProxyList.forEach(e => {
          if (newInstanceList.indexOf(e.oldInstanceId) == -1) {
            saveFlag = true;
          }
        });
      }
      if (this.relationProxyList && this.relationProxyList.length > 0) {

      } else {
        saveFlag = true;
      }
      if (!saveFlag) {
        this.$message.error('请切换实例！');
        return;
      } else {
        // 如果关系代理列表存在且长度大于0
        if (this.relationProxyList && this.relationProxyList.length > 0) {
          // 遍历关系代理列表
          this.relationProxyList.forEach((e, i) => {
            // 如果代理ID与Butel代理数据的ID相等
            if (e.proxyId == this.butelProxyData.id) {
              // 从关系代理列表中移除该元素
              this.relationProxyList.splice(i, 1);
            }
          });
        }
        localStorage.setItem("relationProxyList", JSON.stringify(this.relationProxyList));
        const loading = this.$loading({
          lock: true,
          text: '加载中...',
          // spinner: 'el-icon-loading',
          background: 'rgba(55, 55, 55, 0.4)'
        });
        let _this = this;
        this.$axios.post(this.baseUrl3 + 'management3/proxy/update', data)
          .then(({data: {msg, data, code}}) => {
            if (code == 20000) {
              this.isShowIgnore = false;
              if (this.flag == 1) {
                this.initData();
              } else if (this.flag == 2) {
                this.getProxyList();
              }
              // _this.initData();
              _this.resetForm(true);
            } else {
              _this.$message({showClose: true, message: msg, type: 'error'});
              console.log(msg)
            }
            loading.close();
          })
          .catch(err => {
            console.log(err);
            setTimeout(() => {
              loading.close();
            }, 2000);
          })
      }
    },
    saveProxyClick(formName) {
      for (let i = 0; i < this.butelProxyData.list.length; i++) {
        let item = this.butelProxyData.list[i];
        if (item.showInstanceFlag) {
          this.$message({
            showClose: true,
            message: "请处理已删除的实例",
            type: "warning"
          });
          return
        }
      }
      if (this.current == null) {
        if (!this.isEdit) {
          this.$message({
            showClose: true,
            message: "请选择模块类型",
            type: "warning"
          });
          return
        }
      }
      let _this = this;
      this.$refs[formName].validate((valid) => {
        if (valid) {
          _this.saveProxy();
        } else {
          return false;
        }
      });
    },
    delButelProxyConfirm(id) {
      this.$confirm('您确认要删除吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.delButelProxy(id)
      }).catch(() => {

      });
    },
    delButelProxy(id) {
      let data = {
        "id": id,
      };
      let _this = this;
      this.$axios.post(this.baseUrl3 + 'management3/proxy/del', data)
        .then(({data: {msg, data, code}}) => {
          if (code == 20000) {
            this.initData();
          } else {
            _this.$message({showClose: true, message: msg, type: 'error'})
            console.log(msg)
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    editButelProxy(item) {
      this.ButelProxyTitle = "编辑ButelProxy";
      this.isEdit = true;
      if (this.flag == 1) {
        this.id = item.id;
      } else {
        this.id = item.proxyId;
      }
      this.initButelProxyById();
      this.netplane = true;
      this.getAvailableNode(item);
    },
    initButelProxyById() {
      var data = {
        id: this.id
      };
      var _this = this;
      this.$axios.post(this.baseUrl3 + 'management3/proxy/proxyinfo', data)
        .then(({data: {msg, data, code}}) => {
          if (code == 20000) {
            this.currentIdcId = data.idcId;
            let _unitInfo = _this.UnitList.filter(u => {
              if (u.alias == data.integrationVersionAlias && u.version == data.integrationVersionVersion) {
                return u
              }
            })[0]
            if (_unitInfo) {
              _this.selectUnit(_unitInfo.id)
              _this.butelProxyData.unitId = _unitInfo.id
            }
            _this.butelProxyData.id = data.id
            _this.butelProxyData.moduleType = data.moduleType
            _this.butelProxyData.moduleVersion = data.moduleVersion
            _this.butelProxyData.deviceId = data.deviceId
            _this.butelProxyData.selectedNodeId = data.nodeId
            _this.deviceChange();
            let objList = data.list;
            let _array = [];

            if (objList) {
              for (let i = 0; i < objList.length; i++) {
                let obj = objList[i];

                //服务 不是自定义的时候再调用  0红云模块   1自定义
                if (obj.type == 0) {
                  this.getNodeIdAndInstanceId(obj, obj.module)
                }
                obj.moduleType = obj.module
                obj.addrGroupId = obj.proxyGroup.id
                obj.isShowIgnore = false
                obj.preNetCardId = obj.sendNetCardId

                let _sourceAddrList = []
                if (obj.sourceIpList) {
                  for (let j = 0; j < obj.sourceIpList.length; j++) {
                    let sourceIpObj = obj.sourceIpList[j];
                    _sourceAddrList.push({
                      // id: sourceIpObj.id,
                      addr: sourceIpObj.srcAddr,
                      ip: sourceIpObj.srcAddr.split(':')[0],
                      port: sourceIpObj.srcAddr.split(':')[1],
                      recvIpCodeStr: obj.recvIp,
                      recvPort: sourceIpObj.recvPort,
                      sendIpCodeStr: obj.sendIp,
                      sendPort: sourceIpObj.sendPort,
                      protocol: sourceIpObj.protocol,
                      attr: sourceIpObj.attr,
                      extendInfo: sourceIpObj.extendInfo,
                      valid: sourceIpObj.valid,
                      // addrInfoId: sourceIpObj.addrInfoId,
                    })
                  }
                }
                _this.$set(obj, 'addrNode', obj.proxyGroup)
                _this.$set(obj, 'addrGroupList', obj.proxyGroup)
                _this.$set(obj, 'sourceAddrList', _sourceAddrList)
                _this.$set(obj, 'freeSource', _sourceAddrList)


                let ignoreAddrList = []
                if (obj.ignoreIpList) {
                  for (let j = 0; j < obj.ignoreIpList.length; j++) {
                    let ignoreObj = obj.ignoreIpList[j];
                    ignoreAddrList.push({
                      // id: sourceIpObj.id,
                      addr: ignoreObj.srcAddr,
                      ip: ignoreObj.srcAddr.split(':')[0],
                      port: ignoreObj.srcAddr.split(':')[1],
                      recvIpCodeStr: obj.recvIp,
                      recvPort: ignoreObj.recvPort,
                      sendIpCodeStr: obj.sendIp,
                      sendPort: ignoreObj.sendPort,
                      protocol: ignoreObj.protocol,
                      attr: ignoreObj.attr,
                      extendInfo: ignoreObj.extendInfo,
                      valid: ignoreObj.valid,
                      // addrInfoId: sourceIpObj.addrInfoId,
                    })
                  }
                }
                _this.$set(obj, 'delAddrList', ignoreAddrList)
                _array.push(obj);
              }
            }
            _this.butelProxyData.list = _array
            _this.butelProxyVisible = true
          } else {
            _this.$message({showClose: true, message: msg, type: 'error'})
            console.log(msg)
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    moduleTypeChangeEdit(idx) {
      let obj = this.butelProxyData.list[idx];
      obj.showInstanceFlag = true
      let data = {
        "sendNetCardId": obj.sendNetCardId,
        "moduleType": obj.moduleType
      }
      obj.instanceList = []
      let _this = this;

      this.$axios.post(this.baseUrl3 + 'management3/proxy/instancelist', data)
        .then(({data: {msg, data, code}}) => {
          if (code == 20000) {
            if (data.instanceList) {
              let addrArray = [];
              for (let i = 0; i < data.instanceList.length; i++) {
                obj.instanceList.push(data.instanceList[i]);
                if (obj.instanceId == data.instanceList[i].instanceId) {
                  addrArray = data.instanceList[i].addrGroupList;
                  obj.showInstanceFlag = false
                }
              }
              _this.recursiveAddrGroup(idx, addrArray);
            }
            _this.getAddrGroup(idx, true);
          } else {
            _this.$message({showClose: true, message: msg, type: 'error'})
            console.log(msg)
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    initData() {
      var data = {
        'pageNo': this.currentPage,
        'pageSize': this.pageSize,
        idcId: this.idcId
      };
      var _this = this;
      _this.tableData = [];
      this.$axios.post(this.baseUrl3 + 'management3/proxy/list', data)
        .then(({data: {msg, data, code}}) => {
          if (code == 20000) {
            if (data.proxyList && data.proxyList.length > 0) {
              _this.tableData = data.proxyList;
              _this.tableData.map(item => {
                _this.$set(item, 'sendMsgLoading', false)
                return item
              })
              _this.totalElement = data.total;
            } else {
              _this.tableData = [];
              _this.totalElement = 0;
            }

          } else {
            _this.$message({showClose: true, message: msg, type: 'error'})
            console.log(msg)
          }
        })
        .catch(err => {
          console.log(err)
        })
    }
  },
  created() {
    this.getListOperations('idclist')
    if (!this.currentMenu) {
      return
    }
    if (this.$route.params.idcId) {
      this.idcId = parseInt(this.$route.params.idcId);
    }

    this.flag = parseInt(this.$route.params.flag);
    this.verifyData = JSON.parse(localStorage.getItem("VerifyData"));

    this.relationProxyList = JSON.parse(localStorage.getItem("relationProxyList"));
    if (this.flag == 1) {
      this.initData();
      this.getDeviceList();
    } else if (this.flag == 2) {
      this.getProxyList();
    }

    this.findIntegration();
    this.getModuleTypeList();
    // this.getInstanceIdList();
  },
  computed: {
    ...mapState(['currentMenu', 'listOperations', 'currentMenuOperations']),
    filterArray() {
      return this.filterArr(this.search, this.moduleArray)
    },
    btnInList() {
      return (name, childName) => {
        let btn = this.listOperations.filter(op => op.name.includes(name));
        if (btn && btn.length > 0) {
          if (!childName) {
            return btn.length > 0
          } else {
            return btn[0].buttonList.some(childOp => childOp.name.includes(childName))
          }
        }
      }
    },
  },
}
</script>

<style>
.notifyStyle {
  width: auto;
}
</style>
<style scoped>

/*/deep/ .collapse-left .el-collapse-item__header{*/

/*}*/
/*/deep/ .collapse-left .el-collapse{*/
/*  border-top: none;*/
/*}*/
/*/deep/ .collapse-left .el-collapse-item__wrap {*/
/*  position: relative;*/
/*}*/

/*/deep/ .collapse-left .el-collapse-item__arrow {*/
/*  position: absolute;*/
/*  left: 0;*/
/*  transform: translateY(-50%);*/
/*  transform: translateX(50%);*/
/*}*/

.selectCss /deep/ .el-input__inner {
  border: 2px solid red;
}
</style>
<style>

.el-loading-spinner {
  background-image: url('../../../assets/loading1.svg');
  background-size: 63px 100px;
  background-repeat: no-repeat;
  height: 30%;
  background-position: center;
  top: 200px;
}

.el-loading-spinner .circular {
  display: none;
}

.el-loading-spinner .el-loading-text {
  margin-top: 150px;
  text-align: center;
}

.navcss {
  font-size: 17px;
  margin-bottom: 15px;
}

.divChecked .active {
  background-color: #409eff;
  border-color: #409eff;
}

.activeAddr {
  background-color: #327ecc !important;
  border-color: #409eff;
}
</style>
